import FaceTrackerServer from './FaceTrackerServer';
import FPS from './FPS';
import { CheckDirectionStatus, DirectionToTrack } from '@/api/facetracker/FaceTracker';

export { FaceTrackerServer, FPS };

export const enum Direction {
  None = 0,
  Left = 1,
  Right = 2,
  Up = 3,
  Down = 4,
  Center = 5
}

export function directionToDegree(dir: Direction): number {
  switch (dir) {
    case Direction.Left:
      return 180;
    case Direction.Up:
      return -90;
    case Direction.Down:
      return 90;
    case Direction.Right:
    case Direction.Center:
    case Direction.None:
      return 0;
  }
}

/** サーバーと定義を合わせる */
export const enum TrackerStatus {
  None = -1,
  EstablishingSession = 0,
  Calibrating = 1,
  TakingSelfie = 2,
  InitializingDirections = 3,
  Detecting = 4,
  Ended = 5,
  InError = 99
}

export const enum TrackerType {
  Server = 'server'
}

export const enum ErrorType {
  Unknown,
  FaceNotFound,
  Timeout,
  ServerError,
  Network,
  Loading,
  DifferentDirection,
  InvalidScreenOrientation,
  CVInvalidFeatureBrightness,
  CVInvalidFeatureSharpness,
  CVInvalidFeatureHighlight,
  CVInvalidFeatureSunglass,
  CVInvalidFeatureStraight,
  CVInvalidFeatureIsGrayscale
}

export interface ApiErrorResponse {
  error_code: ApiErrorCode;
  error_message: string;
  fields?: string[];
}

/** エラーコード。サーバーと定義を合わせる */
export const enum ApiErrorCode {
  None = '0',

  CVInvalidFeature = '2007', // @/resources/error/ErrorCode ErrorCode.CVInvalidFeature,

  CalibrationTimeout = '4001',
  DetectionTimeout = '4002',
  FaceNotFound = '4003',
  DifferentDirection = '4004',

  CalibrationTimeoutWithManyRetry = '4101',
  DetectionTimeoutWithManyRetry = '4102',
  FaceNotFoundWithManyRetry = '4103',
  DifferentDirectionWithManyRetry = '4104'
}

export interface FaceResult {
  result: CheckDirectionStatus;
  error?: ErrorType;
  isManyRetry?: boolean;
}

export interface CalibrationResult {
  status: CalibrationStatus;
  currentCount: number;
  maxCount: number;
  error?: ErrorType;
  isManyRetry?: boolean;
}

export interface TakeSelfieResult {
  isSuccess: boolean;
  error?: ErrorType;
}

export interface InitializeDirectionsResult {
  directions: DirectionToTrack[];
  error?: ErrorType;
}

export const enum CalibrationStatus {
  Processing,
  Completed,
  InError
}

/** 首振りの進捗。サーバーと定義を合わせる */
export const enum DirectionDetectionPhase {
  None = -1,
  Phase1 = 0,
  Center1 = 1,
  Phase2 = 2,
  Center2 = 3,
  Phase3 = 4,
  Completed = 5
}
